exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-background{position:relative}.kv-background video{height:100%;width:100%;object-fit:cover}.kv-background .simpleParallax{position:absolute;left:0;right:0;top:0;bottom:0}.kv-edit-mode .kv-background{transition:all .3s ease-in-out}.kv-edit-mode .kv-video:after{content:\" \";left:0;right:0;top:0;bottom:0;position:absolute;background-color:rgba(42,44,46,.35)}.swiper-section [data-type=swipe-list]{display:block!important}@media (min-width:768px){.swiper-section [data-type=swipe-list]{display:none!important}}.kv-edit-mode .swiper-section [data-type=swipe-list]{display:block!important}", ""]);

// exports
